<template>
  <div class="body-wrap">

    <!-- 搜索 -->
    <div class="search-wrap" >
      <div class="opt-wrap">
        <el-button size="mini" type="primary" v-if="ERP.isPermission(4001004001)" @click="editItem()" icon="el-icon-plus">添加分类编码</el-button>
      </div>
      <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
      <el-button size="mini" type="primary" @click="getList(1)" :loading="searchLoading">搜索</el-button>
    </div>

    <!-- 数据列表 -->
    <div class="table-wrap" >
      <el-table border v-loading="searchLoading" :data="tableData">
        <el-table-column prop="id" label="ID" align="center" width="50"></el-table-column>
        <el-table-column prop="no" label="税目分类编码" align="center"></el-table-column>
        <el-table-column prop="name" label="税目分类名称" align="center"></el-table-column>
        <el-table-column prop="create_admin" label="创建人" align="center"></el-table-column>
        <el-table-column prop="create_time_formatted" label="创建日期" align="center"></el-table-column>
        <el-table-column prop="update_admin" label="修改人" align="center"></el-table-column>
        <el-table-column prop="update_time_formatted" label="修改日期" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="primary" v-if="ERP.isPermission(4001004002)" size="mini" icon="el-icon-edit" @click="editItem(scope.row)">编辑</el-button>
            <el-button type="danger" v-if="ERP.isPermission(4001004003)" size="mini" icon="el-icon-delete" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
    </div>

    <!-- 添加窗口 -->
    <el-dialog title="添加分类编码" :visible.sync="dialogVisible" :close-on-click-modal="true" class="business-dialog" width="400px">

      <el-form ref="form" :rules="rules" :model="form" label-width="120px" size="mini" style="margin-right: 20px;">
        <el-form-item label="税目分类编码" prop="no">
          <el-input v-model="form.no" placeholder="请填写税目分类编码"></el-input>
        </el-form-item>
        <el-form-item label="税目分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请填写税目分类名称"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()" :loading="submitLoading">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
export default {
  name: 'goods-tax',
  data () {
    return {
      total: 0,
      tableData: [],
      keyword: '',
      page: 1,
      pageSize: 12,
      searchLoading: false,
      dialogVisible: false,
      submitLoading: false,
      form: {},
      defValue: {
        id: '',
        name: '',
        no:''
      },
      rules: {
        name: [
          { required: true, message: '请填写税目分类名称。', trigger: 'blur' },
        ],
        no: [
          { required: true, message: '请填写税目分类编码。', trigger: 'blur' },
        ],
      },
    }
  },
  beforeMount() {
    this.form = this.getFormData()
  },
  mounted() {
    this.getList()
  },
  methods: {

    getFormData(data) {
      return Object.assign({}, this.defValue, data)
    },

    editItem(data) {

      if(data) {
        this.form = {id: data.id, name: data.name, no: data.no}
      } else {
        this.form = this.getFormData()
      }

      this.dialogVisible = true

    },

    getList(p) {
      if(p)this.page = p
      this.$myhttp.get('admin/getGoodsTaxNoList', {params: {page: this.page, page_size: this.pageSize, keyword: this.keyword}}).then(resp => {
        let res = resp.data
        if(res.code == 200) {
          this.tableData = res.data
          this.total = res.total
        } else {
          this.tableData = []
          this.total = 0
        }

      })
    },

    pageChange(data) {
      this.page = data
      this.getList()
    },

    submit() {

      this.$refs['form'].validate((valid) => {
        if (valid) {

          let data = Object.assign({}, this.form)
          this.$myhttp.post('admin/saveGoodsTaxNo', data).then(res => {
            this.message(res.data)
            if(res.data.code == 200) {
              this.getList()
              this.dialogVisible = false
            }
          })

        } else {
          return false;
        }
      });

    },

    deleteItem(data) {

      this.$confirm(`此操作将删除 [ ${data.name} ]，是否继续?`, '提示', {type: 'warning'}).then(() => {
        this.$myhttp.post('admin/deleteGoodsTaxNo', data).then(res => {
          this.message(res.data)
          if(res.data.code == 200) {
            this.getList()
          }
        })
      })

    },

    message(res) {
      this.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
    },

  },

}
</script>
<style lang="scss" scoped>

  @import './common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/GoodsTaxCode.vue